import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {Link} from 'react-router';
import {CSSProperties} from 'react';
import {RealCampusDashboardCard} from './RealCampusDashboardCard';
import {connect} from 'react-redux';
import * as Request from '../tgccRequest';


// ProofBase is defined in web.config
// and loaded in default.aspx or index.html
declare var ProofBase;

const listStyle: CSSProperties = {
    position: 'relative',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    display:'flex',
    flexWrap:'wrap',
    justifyContent:'center'
}
const orderStyle: CSSProperties = {
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: '4px 6px',
    padding: '5px',
    background: Tgcc.Styles.paleWhite,
    cursor:'pointer',
    overflow:'auto',
    width:'360px',
    height:'565px',
    textTransform:'none'
}

const imgStyle: CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    height: 'auto',
    width: '350px',
}

const orderTextStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
}
const idTextStyle    : CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'BarlowBlack',
    fontSize: '20px',
    letterSpacing: '3px',
    lineHeight: '22px',
    color:'#616060'
}
let subTextStyle = Object.assign({}, idTextStyle, {fontSize: '16px', lineHeight: '15px', letterSpacing: '1px',fontFamily:'BarlowLight',flexDirection:'row'});
let textStyle = Object.assign({},idTextStyle, {fontFamily:'BarlowMedium',fontSize:'16px'})

const trackingLink: CSSProperties = {
    color:'blue',
    textDecoration:'underline'
}

class Props extends Tgcc.BaseProps {
    loginData: Tgcc.LoginData;
}

export class _RealCampusOrderHistory extends React.Component<Props, any>{

    state = {
        history: null,
        error: null,
        isWaiting: true
    }

    componentWillMount(){
        this.loadHistory(this.props);
    }

    componentWillReceiveProps(props: Props){
        this.loadHistory(props)
    }

    loadHistory = (props: Props) => {
        if(props.loginData){
            if(!this.state.history){
                Request.getProofHistory(props.loginData, this.historyLoaded, this.historyError);
            } else if( props.loginData.impersonate) {
                this.setState({history: null, isWaiting: true});
                Request.getProofHistory(props.loginData, this.historyLoaded, this.historyError);
            } else if (this.state.history.length) {
                var ord1: Tgcc.Proof = this.state.history[0]
                if(ord1.userEmail != props.loginData.username){
                    this.setState({history: null, isWaiting: true});
                    Request.getProofHistory(props.loginData, this.historyLoaded, this.historyError);
                }
            }
        }
    }

    historyLoaded = (proofs: Tgcc.Proof[]) => {
        this.setState({ history: proofs, isWaiting: false });
    }

    historyError = (err) => {
        this.setState({history: [], error: err, isWaiting: false});
    }

    handleMissingProofImage = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }
    
    showPopup = (proof: Tgcc.Proof) => {
        this.props.dispatch({type: Tgcc.StateAction.RealCampusProofPopup, payload: proof});
    }

    doTracking = (evt: React.MouseEvent<HTMLDivElement>, tracking: string) =>{
        evt.stopPropagation();
        window.open("https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=" + tracking, "tgcctracking");
    }
    getStatusColor(proofStatus:string){
        if (proofStatus === 'CANCELLED'){
            return Object.assign({},{},{color:'red'});
        }
        else {
            return Object.assign({},{},{color:'#616060'});
        }

    }
    
    getOrderItem = (order: Tgcc.Proof) => {
        var underlineTextStyle = Object.assign({}, subTextStyle);
        var event = order.eventName ? <div style={subTextStyle}>{order.eventName}</div> : null;
        var tracking = order.tracking ? 
            <div style={underlineTextStyle} onClick={ (evt) => this.doTracking(evt, order.tracking)}>Tracking: <span style={trackingLink}>{order.tracking}</span></div> 
            : null;
        return (
            <div key={order.proofId} onClick={ () => this.showPopup(order)}>
                <div style={orderStyle} className="hoverBorder">
                    <img style={imgStyle} src={Tgcc.getProofPath(order.proofId)} onError={this.handleMissingProofImage} />
                    <div style={orderTextStyle} className="textActive">
                        {event}
                        <div style={subTextStyle}><span style={textStyle}>Shipped:</span> {order.shipDate}</div>
                        <div style={subTextStyle}><span style={textStyle}>Status:</span><span style={this.getStatusColor(order.status)}>{order.status}</span></div>
                        <div style={subTextStyle} className="csrActive"><span style={textStyle}>CSR:</span>{order.csrName} - {order.csrEmail}</div>
                        {tracking}
                    </div>
                </div>
            </div>
        )
    }

    getOrders = () => {
        var elements = new Array();
        if(this.state.history){
            for(var i in this.state.history){
                var p: Tgcc.Proof = this.state.history[i];
                elements.push(this.getOrderItem(p));
            }
        }
        return elements;
    }
    
    render(){
        var errorElement = this.state.error? <div style={Tgcc.Styles.error}>{this.state.error}</div> : null
        var ordersHistory = this.getOrders();
        var waiting = this.state.isWaiting ? Tgcc.workingGif : null;
        return (
            <RealCampusDashboardCard>
                {errorElement}
                <div style={listStyle} className='campActOrders'>
                    {ordersHistory}
                    {waiting}
                </div>
            </RealCampusDashboardCard>
        )
    }
}


const mapStateToProps = (state: Tgcc.GlobalState) => {
    var lData = state.LoginData ? state.LoginData : null;
    return { 
        loginData: lData
    };
};
    
export var RealCampusOrderHistory = connect(mapStateToProps)(_RealCampusOrderHistory);
